import type { TOC } from '@ember/component/template-only';
import GeneralEmbeddedApp from 'lumen/components/general/embedded-app';
import type MarketRevpakExportsController from 'lumen/controllers/market/revpak-exports';
import getEnv from 'lumen/helpers/get-env';

interface MarketRevpakExportsSignature {
  Args: {
    controller: MarketRevpakExportsController;
    model: unknown;
  };
}

<template>
  <GeneralEmbeddedApp
    {{! @glint-expect-error: Incorrect type }}
    @baseURL={{getEnv "spiderIframeURL"}}
    @id="spider-market-revpak-exports"
    @query={{@controller.iframeQPs}}
    @url="/revpak/exports"
  />
</template> satisfies TOC<MarketRevpakExportsSignature>;
